import React from 'react';
import { SUGGEST_FRIENDLY_IDS } from '../../../../apollo/queries/priceChangeRequest';
import { GenericFilterHeader } from './GenericFilterHeader';

interface FriendlyIdHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

export function FriendlyIdHeader({
    currentValue,
    onChange,
}: FriendlyIdHeaderProps) {
    return (
        <GenericFilterHeader
            label="#"
            suggestProps={{
                label: '#',
                query: SUGGEST_FRIENDLY_IDS,
                optionExtractor: data =>
                    (data?.suggestFriendlyIds ?? []).map((id: number) =>
                        id.toString(),
                    ),
            }}
            currentValue={currentValue}
            onChange={onChange}
        />
    );
}

FriendlyIdHeader.displayName = 'FriendlyIdHeader';
